<template>
  <b-container
    fluid
    class="signin-wrapper d-flex flex-column align-items-center"
  >
    <alerts-component />
    <b-row
      class="d-flex flex-column align-items-center"
      style="max-width:500px;"
    >
      <div class="logo">
        <img src="@/assets/BET_logo_symbol.png">
      </div>
      <b-card>
        <b-form
          v-if="viewState === 'signIn'"
          id="sign-in-form"
          @submit.stop.prevent="onSubmit"
        >
          <b-form-group
            id="input-group-1"
            label="Email Address"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="$v.form.login.email.$model"
              type="email"
              placeholder="Enter email"
              :state="validateState('login.email')"
              aria-describedby="input-1-live-feedback"
            />
            <b-form-invalid-feedback id="input-1-live-feedback">
              This is a required email field
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="input-group-2"
            label="Password"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="$v.form.login.password.$model"
              type="password"
              placeholder="Enter password"
              :state="validateState('login.password')"
              aria-describedby="input-2-live-feedback"
            />
            <b-form-invalid-feedback id="input-2-live-feedback">
              This is a required password field
            </b-form-invalid-feedback>
          </b-form-group>
          <div class="d-flex justify-content-end">
            <b-button
              type="submit"
              variant="primary"
            >
              Log In
            </b-button>
          </div>
        </b-form>
        <b-form
          v-if="viewState === 'resetPassword'"
          id="forgot-password-form"
          @submit.stop.prevent="sendPasswordReset"
        >
          <b-form-group
            id="input-group-3"
            label="Email Address"
            label-for="input-3"
            description="Please enter a valid email to receive password reset instructions."
          >
            <b-input
              id="input-3"
              v-model="$v.form.reset.email.$model"
              type="email"
              :state="validateState('reset.email')"
              aria-describedby="input-email-live-feedback"
            />
            <b-form-invalid-feedback id="input-email-live-feedback">
              Please enter a valid email address
            </b-form-invalid-feedback>
          </b-form-group>
          <div class="d-flex justify-content-end">
            <b-button
              class="mr-1"
              variant="secondary"
              @click="viewState = 'signIn'"
            >
              Cancel
            </b-button>
            <b-button
              type="submit"
              variant="primary"
            >
              Submit
            </b-button>
          </div>
        </b-form>
        <div v-if="viewState === 'resetRequested'">
          <h4>Password Reset Requested</h4>
          <p>
            If your account is associated with your provided email address, you will receive an email to reset your
            password. If you don't, please try another email.
          </p>
          <div class="d-flex justify-content-end">
            <b-button
              variant="primary"
              @click="viewState = 'signIn'"
            >
              Back to Login
            </b-button>
          </div>
        </div>
        <div
          v-if="failed"
          style="color: red;"
        >
          {{ errorMessage }}
        </div>
        <template
          v-if="viewState === 'signIn'"
          v-slot:footer
        >
          <div class="d-flex justify-content-center">
            <a
              href="#"
              @click="viewState = 'resetPassword'"
            >Forgot password?</a>
          </div>
        </template>
      </b-card>
    </b-row>
  </b-container>
</template>
<script>
  import {required, email} from "vuelidate/lib/validators";
  import AlertsComponent from "../../components/AlertsComponent";
  import validateStateMixin from "../../mixins/validateStateMixin";

  export default {
    components: {AlertsComponent},
    mixins: [validateStateMixin],
    data() {
      return {
        form: {
          login: {
            email: "",
            password: ""
          },
          reset:{
            email: ""
          }
        },
        failed: false,
        errorMessage: "",
        viewState: "signIn"
      };
    },
    watch:{
      form:{
        handler (value){
          if (this.viewState === 'signIn') {
            value.reset.email = value.login.email
          }else{
            value.login.email = value.reset.email
          }
        },
        deep:true
      }
    },
    validations: {
      form: {
        login: {
          email: {
            required,
            email
          },
          password: {
            required
          }
        },
        reset:{
          email: {
            required,
            email
          },
        }
      }
    },
    methods: {
      onSubmit(evt) {
        evt.preventDefault();
        this.$v.form.login.$touch();
        if (this.$v.form.login.$anyError) {
          return;
        }
        this.$store
          .dispatch("login", {
            email: this.form.login.email,
            password: this.form.login.password
          })
          .then(() => {
            this.$router.push({name: "home"});
          })
          .catch(error => {
            this.handleErrorResponse(error)
          });
      },
      async sendPasswordReset(evt) {
        evt.preventDefault();
        this.$v.form.reset.$touch();
        if (this.$v.form.reset.$anyError) {
          return;
        }
        try {
          await this.$http.post('authentication/sendPasswordRecovery', {email: this.form.reset.email});
          this.viewState = 'resetRequested'
        } catch (error) {
          this.handleErrorResponse(error);
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "bootstrap/scss/_functions.scss";
  @import "bootstrap/scss/_variables.scss";
  @import "bootstrap/scss/_mixins.scss";
  @import "@/assets/variables.scss";

  .signin-wrapper {
    padding-top: 150px;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.03);

    @include media-breakpoint-only(xs) {
      padding-top: 0px;
      justify-content: center;
    }
  }

  .logo {
    margin-bottom: 25px;

    img {
      width: 100px;
    }
  }

  a {
    color: $dark-grey;

    &:hover {
      text-decoration: none;
    }
  }

</style>
